import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { CTALeftImageRight as CTALeftImageRightEditor } from "./cta-left-image-right"
import { CTALeftImageRightSettings } from "./cta-left-image-right-settings"
import CTALeftImageRightPreview from "./cta-left-image-right-preview.png"

export const CTALeftImageRight = {
  name: "CTALeftImageRight",
  label: "call to action on left, image on right",
  EditorComponent: CTALeftImageRightEditor,
  SettingsComponent: CTALeftImageRightSettings,
  image: CTALeftImageRightPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    headingColor: "#000000",
    textColor: "#4d4d4d",
    image: "",
    alt: "",
    imageUrl: "",
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    columnRatio: 50,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    gap: 30
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Build your home studio with less than $500"),
      paragraph(
        "I recently turned my guest bedroom into a recording studio. Here's how I did it with a few hundred dollars."
      ),
      button("Check out my studio")
    ])
  ]
}
